import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import Marquee from "react-fast-marquee";
import { 
    Home, Building2, Hammer, Users, Warehouse, 
    Sprout, Pickaxe, TrafficCone, Droplets, Mountain,
    Trash2, CheckCircle2, FileText, Calendar,
    MessageSquare, Wrench, ArrowRight, Shield,
    Award, Handshake, HardHat
} from 'lucide-react';

// Image assets
import Banner from '../assets/images/companyservices/home-slide-3-long.jpeg'
import ServicePre from '../assets/images/companyservices/service-pre-1s.jpeg'
import Design from '../assets/images/des-2.png';
import Vehicle2 from '../assets/images/vehicle-2.svg';

// Custom components
import GetInTouch from '../components/GetInTouch';
import Machinery from '../components/Machinery';

// Benefits data
import { benefits } from '../Benefits';

import { Carousel } from 'react-bootstrap';
import { workProcess } from '../WorkProcess';

const Services = () => {
    const servicesData = [
        {
            title: "Construction & Building",
            items: [
                { icon: Home, text: "New residential homes and accommodation buildings" },
                { icon: Building2, text: "Commercial buildings and office fit-outs" },
                { icon: Hammer, text: "Renovations, refurbishments, and interior upgrades" },
                { icon: Users, text: "Staff accommodation and multi-unit developments" },
                { icon: Warehouse, text: "Temporary and semi-permanent structures" },
            ],
        },
        {
            title: "Earthworks & Civil Works",
            items: [
                { icon: Mountain, text: "Earthworks and site preparation" },
                { icon: TrafficCone, text: "Access roads, driveways, and civil works" },
                { icon: Droplets, text: "Drainage, trenching, and underground services" },
                { icon: Pickaxe, text: "Crushing and screening operations" },
            ],
        },
        {
            title: "Specialist & Support Services",
            items: [
                { icon: Sprout, text: "Greenhouses, sheds, and agricultural buildings" },
                { icon: Trash2, text: "Demolition and site clearance" },
                { icon: CheckCircle2, text: "Completion of partially built developments" },
            ],
        },
    ];

    const commitments = [
        {
            icon: Award,
            title: "Quality Workmanship",
            description: "Attention to detail in every project we undertake"
        },
        {
            icon: FileText,
            title: "Honest Pricing",
            description: "Clear scope definition and transparent pricing"
        },
        {
            icon: Handshake,
            title: "Strong Relationships",
            description: "Built with clients, consultants, and councils"
        },
        {
            icon: Shield,
            title: "Safety First",
            description: "Full compliance with NZ health and safety regulations"
        }
    ];

    return (
        <div>
            <style>{`
                .services-carousel {
                    position: relative;
                    padding-bottom: 50px;
                }

                .services-carousel .carousel {
                    position: relative;
                }

                .services-carousel .carousel-inner {
                    min-height: 400px;
                }

                .services-carousel .carousel-item {
                    transition: opacity 0.8s ease-in-out;
                }
                
                .services-carousel .carousel-indicators {
                    position: absolute;
                    bottom: -40px;
                    margin-bottom: 0;
                }

                .services-carousel .carousel-indicators button {
                    background-color: #ff6b35;
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    margin: 0 5px;
                }

                .service-item-icon {
                    display: flex;
                    align-items: flex-start;
                    gap: 15px;
                    margin-bottom: 20px;
                    padding: 15px;
                    border-radius: 10px;
                    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                    transition: all 0.3s ease;
                }

                .service-item-icon:hover {
                    transform: translateX(10px);
                    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                }

                .service-item-icon .icon-wrapper {
                    min-width: 45px;
                    height: 45px;
                    background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    box-shadow: 0 4px 10px rgba(255, 107, 53, 0.3);
                }

                .service-item-icon p {
                    margin: 0;
                    line-height: 1.6;
                    flex: 1;
                    align-self: center;
                    color: #333;
                    font-weight: 500;
                }

                .work-process-container {
                    position: relative;
                    padding: 60px 0;
                }

                .process-step {
                    text-align: center;
                    position: relative;
                    padding: 30px 20px;
                    background: white;
                    border-radius: 15px;
                    box-shadow: 0 5px 20px rgba(0,0,0,0.08);
                    transition: all 0.3s ease;
                    height: 100%;
                }

                .process-step:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 10px 30px rgba(0,0,0,0.15);
                }

                .process-step-number {
                    width: 60px;
                    height: 60px;
                    background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 20px;
                    color: white;
                    font-size: 24px;
                    font-weight: bold;
                    box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
                }

                .process-step-icon {
                    width: 70px;
                    height: 70px;
                    margin: 0 auto 20px;
                }

                .process-step h4 {
                    color: #333;
                    margin-bottom: 15px;
                    font-weight: 600;
                }

                .process-step p {
                    color: #666;
                    font-size: 14px;
                    line-height: 1.6;
                }

                .process-arrow {
                    position: absolute;
                    top: 50%;
                    right: -30px;
                    transform: translateY(-50%);
                    z-index: 10;
                    color: #ff6b35;
                }

                @media (max-width: 768px) {
                    .process-arrow {
                        display: none;
                    }
                }

                .commitment-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 30px;
                    margin-top: 40px;
                }

                .commitment-card {
                    text-align: center;
                    padding: 40px 30px;
                    background: white;
                    border-radius: 15px;
                    box-shadow: 0 5px 20px rgba(0,0,0,0.08);
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                }

                .commitment-card::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 4px;
                    background: linear-gradient(90deg, #ff6b35 0%, #ff8c42 100%);
                    transform: scaleX(0);
                    transition: transform 0.3s ease;
                }

                .commitment-card:hover::before {
                    transform: scaleX(1);
                }

                .commitment-card:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 15px 40px rgba(0,0,0,0.12);
                }

                .commitment-icon {
                    width: 70px;
                    height: 70px;
                    background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 25px;
                    color: white;
                    box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
                }

                .commitment-card h4 {
                    color: #333;
                    margin-bottom: 15px;
                    font-weight: 600;
                    font-size: 20px;
                }

                .commitment-card p {
                    color: #666;
                    line-height: 1.6;
                    margin: 0;
                }

                .commitment-intro {
                    text-align: center;
                    max-width: 800px;
                    margin: 0 auto 50px;
                    padding: 30px;
                    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                    border-radius: 15px;
                    border-left: 4px solid #ff6b35;
                }

                .commitment-intro h2 {
                    color: #333;
                    margin-bottom: 0;
                    font-size: 28px;
                    font-weight: 600;
                }
            `}</style>

            {/* Breadcrumb Navigation */}
            <section id="breadcrumbs" className="breadcrumbs" style={{
                backgroundImage: `url(${Banner})`
            }}>
                <div className="container">
                    <h1>Services</h1>
                    <ul>
                        <li><a href="./">Home</a></li>
                        <li>Services</li>
                    </ul>
                </div>
            </section>

            {/* Introduction Section */}
            <section className="entry services-section">
                <Container>
                    <Row>
                        {/* Left Column - Image */}
                        <Col md={5} className="position-relative">
                            <img
                                src={ServicePre}
                                alt="Ready Mix Concrete manufacturers"
                                className="img-fluid my-auto"
                            />
                            <img
                                src={Design}
                                alt="Design"
                                className="des-2"
                            />
                        </Col>

                        {/* Right Column - Text */}
                        <Col md={7} className="my-auto">
                            <h3>Our Services</h3>
                            <div className="services-carousel">
                                <Carousel controls={false} indicators={true} interval={5000} fade>
                                    {servicesData.map((slide, index) => (
                                        <Carousel.Item key={index}>
                                            <h2>{slide.title}</h2>
                                            <div>
                                                {slide.items.map((item, i) => {
                                                    const IconComponent = item.icon;
                                                    return (
                                                        <div key={i} className="service-item-icon">
                                                            <div className="icon-wrapper">
                                                                <IconComponent size={24} />
                                                            </div>
                                                            <p>{item.text}</p>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </Carousel.Item>
                                    ))}
                                </Carousel>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Work Process Section */}
            <section className="section-bg bg-1">
                <Container>
                    <div className="text-center">
                        <h3 className="type-2">How we work</h3>
                    </div>

                    <div className="work-process-container">
                        <Row>
                            {workProcess.map((process, index) => (
                                <Col md={3} key={index} className="mb-4 position-relative">
                                    <div className="process-step">
                                        <div className="process-step-number">{index + 1}</div>
                                        <h4>{process.name}</h4>
                                        <p>{process.description}</p>
                                    </div>
                                    {index < workProcess.length - 1 && (
                                        <div className="process-arrow d-none d-md-block">
                                            <ArrowRight size={40} strokeWidth={2.5} />
                                        </div>
                                    )}
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Container>

                {/* Animated Marquee with Vehicle Icon */}
                <Marquee direction="right" gradientWidth={10} className="mt-2">
                    <img src={Vehicle2} alt="Vehicle" />
                </Marquee>
            </section>

            {/* Commitment Section */}
            <section>
                <Container className="py-5">
                    <div className="text-center">
                        <h3 className="type-2">Our Commitment</h3>
                    </div>

                    <div className="commitment-intro">
                        <h2>We are committed to excellence in every project</h2>
                    </div>

                    <div className="commitment-grid">
                        {commitments.map((commitment, index) => {
                            const IconComponent = commitment.icon;
                            return (
                                <div key={index} className="commitment-card">
                                    <div className="commitment-icon">
                                        <IconComponent size={32} strokeWidth={2} />
                                    </div>
                                    <h4>{commitment.title}</h4>
                                    <p>{commitment.description}</p>
                                </div>
                            );
                        })}
                    </div>
                </Container>
            </section>

            {/* Contact Section */}
            <GetInTouch />
        </div>
    );
};

export default Services;
